import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-l', 'LetterL', [["path",{"d":"M7 4v16h10"}]]);